import { useState } from "react";
import { useLazyGetInstallationsQuery } from "../../../Store/Builder/techsbook.api";
import { useEffect } from "react";
import showToast from "../../Hooks/toast";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../Store/Slice/techsbookSlice";

const useGetInstallationsApi = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [getInstallations] = useLazyGetInstallationsQuery();
  const get = () => {
    dispatch(setLoader(true));
    getInstallations()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setData(res);
        showToast(res?.message ?? "Success", "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    get();
  }, []);

  return {
    data,
  };
};

export default useGetInstallationsApi;
